import React from 'react';
import { Booking } from './features/Booking/Booking';

function App() {
  return <Booking />;
}

export default App;
